import { DEVICES_TYPE } from './constants';
export const decodeHtml = inputHtml => {
  if (!inputHtml) {
    return;
  }
  let re;
  re = new RegExp('&lt', 'g');
  inputHtml = inputHtml.replace(re, '<');
  re = new RegExp('&gt', 'g');
  inputHtml = inputHtml.replace(re, '>');
  return inputHtml;
};

export function formatPostMessage(pmEvent) {
  try {
    if (typeof pmEvent === 'string') {
      return JSON.parse(pmEvent);
    }
    return pmEvent;
  } catch (e) {
    return {};
  }
}

export function isMobileDevice(deviceType) {
  return (
    deviceType === DEVICES_TYPE.MOBILE || deviceType === DEVICES_TYPE.TABLET
  );
}

export function getUrlOrigin() {
  return document && document.referrer ? document.referrer : '*';
}
function camelToDash(str) {
  if (typeof str !== 'string') {
    return str;
  } else {
    return str
      .replace(/\W+/g, '-')
      .replace(/([a-z\d])([A-Z])/g, '$1-$2')
      .toLowerCase();
  }
}
export function setElementStyle(element, styleObj, isImportant) {
  let key, dashed;
  isImportant = isImportant ? 'important' : '';
  if (element) {
    for (key in styleObj) {
      if (styleObj.hasOwnProperty(key)) {
        if (isImportant && element && element.style.setProperty) {
          //Need to convert camel case to dash case for this api
          dashed = camelToDash(key);
          try {
            element.style.setProperty(dashed, '' + styleObj[key], isImportant);
          } catch (e) {
            element.style.setProperty(
              dashed,
              '' + styleObj[key],
              '!' + isImportant
            );
          }
        } else {
          element.style[key] = styleObj[key];
        }
      }
    }
  }
}
